import { metadata, SVOD_RAIL_BONUSES, SVOD_RAIL_TVOD } from "lacinetek-common/src/metadata"

import { useTranslation } from "lib/i18n/translation"

import { ProductCard } from "components/subscription/product-card"
import { Products } from "components/common"
import { BlockTitle } from "../block-title"

const CategoryList = ({ category }) => {

	return (
		<>
			<BlockTitle block={category} />
			<Products products={category.products.items} getVideoIds={true}>
				{(products, loading) => (
					<ul className="list films selection">
						{products.map((product, index) => (
							<li
								key={index}
								className="item"
							>
								<ProductCard product={product} />
							</li>
						))}
					</ul>
				)}
			</Products>
		</>
	)
}

export const List = ({ block }) => {
	const { c } = useTranslation("common")

	const categories = block.children.items.filter(category => (
		!metadata(category, SVOD_RAIL_BONUSES) && metadata(category, SVOD_RAIL_TVOD) !== "Oui"
	))

	return (
		<section>
			<h2 className="hidden">{c("movies")}</h2>
			{categories.map((category, index) => (
				<CategoryList
					key={index}
					category={category}
				/>
			))}
		</section>
	)
}
